<div class="menu-group-box">
  <div class="menu-group-head">
    <div class="menu-group-tit">
      <i class="ic ic-menu3"></i>
      <span class="txt">지역별 우리말</span>
    </div>
  </div>

  <div class="menu-group-body">
    <div class="label-select-list">
      <div *ngFor="let regionInfo of REGION_INFO2_LIST"
           (click)="onGotoDialistList($event, regionInfo.region2)"
           class="label-select-box" >

        <div class="label">
          <span class="txt-box type-{{ regionInfo.css }}" [innerHTML]="regionInfo.name | citySize | resize | keepHtml"></span>
        </div>
      </div>

    </div>
  </div>
</div>

<app-region-menu (changeCity)="onChangeCity($event)"></app-region-menu>

<div class="menu-group-box" data-type="story">

  <div class="menu-group-head">
    <div class="menu-group-tit">
      <i class="ic ic-menu2"></i>
      <span class="txt">이야기 모아 보기</span>
    </div>
  </div>


  <div class="menu-group-body">

    <div class="story-item-list scroll-effect2 over-y">

      <a *ngFor="let story of listStory"
         class="story-item-box"
         (click)="onSelectStory($event, story)">

        <div class="img-box">
          <img src="{{ makeImageUrl(story.image ?? null) }}" alt="이미지">
        </div>
        <div class="info-box">{{ story.title }}</div>
      </a>


    </div>

  </div>

</div>

